// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/PrintChar21.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/so.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-load-in {
    text-align: left;
    margin-top: .5em;
    margin-bottom: .5em;
    white-space: nowrap;
    overflow: hidden;
    font-size: .8em;
}

.text-status-complete {
    color: #6BF178;
}

@font-face {
    font-family: 'Print Char';
    src: local('PrintChar'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

.printchar {
    font-family: 'Print Char';
}

.button-startup {
    color: #6BF178;
    background-color: #02111B;
    font-family: 'Print Char';
    padding: 0.5em;
    border: outset thick #6BF178;
    outline: solid .1em #02111B;
    margin: .5em;
}

.button {
    color: #6BF178;
    background-color: #02111B;
    font-family: 'Print Char';
    padding: 0.5em;
    border: outset medium #6BF178;
    outline: solid .1em #02111B;
}

.button-inverted {
    color: #02111B;
    background-color: #6BF178;
    border: outset medium #6BF178;
    font-family: 'Print Char';
    padding: .5em;
    outline: solid .1em #02111B;
}

/*
Startup
*/

.gs-top {
    white-space: pre;
    margin: auto;
    text-align: center;
}
.gs-top-mobile {
    white-space: pre;
    margin: auto;
    text-align: center;
    font-size: .5em;
}

.gs-mobile-screen {
    padding: .5em;
}

.gs-info-desktop {
    min-height: 50vh;
    margin: 2em;
    font-size: 1.1em;
}

.gs-info-mobile {
    font-size: 1.1em;
}

.gs-screen-right {
    display: grid;
    font-size: 1.25em;
}

.gs-info-title {
    background-color: #6bf178;
    color: #02111B;
    padding: .5em;
}

.gs-info-command {
    display: flex;
    font-family: 'Print Char';
}

.gs-info-command-user {
    color: red;
}

.gs-info-command-namespace {
    color: cyan;
}

.gs-info-command-prompt {
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
}

.gs-info-content {
    padding: .5em;
}
.gs-info-user {

}

.gs-image-container {
    border: solid .1em;
    margin: .5em;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-size: cover;
}

/*
Shortcuts
*/
.shortcut-name {
    background-color: #6BF178;
    color: #02111B;
    padding: 0.25em;
    align-items: center;
    display: grid;
    text-align: center;
}

/*
Modal Options
*/

.modal-window-defaults {
    top: 30%;
    max-width: 100%;
    position: relative;
    color: #6BF178;
    z-index: 99;
    left: 1em;
    position: absolute;
    padding: 0;
    border: .25em double #6BF178;
    background-color: rgba(2,17,27,.7);
    font-family: 'Print Char';
    font-size: 1.1em;
}

.title-bar {
    display: flex;
    background-color: #02111B;
    color: #6BF178;
    border-bottom: solid .1em #6bf178;
}

.title-tray {
    max-width: 100%;
    display: flex;
}

.modal-title {
    width: 100%;
    margin: auto;
    padding: .75em;
}

.modal-window-background {
    margin: .1em;
    display: grid;
    padding: .5em;
    background-color: rebeccapurple;
}

.modal-window-container {
    margin: .25em;
    border: .25em double;
    padding: .5em;
    background-color: #02111B;
}

.modal-window-heading {
    margin: -1.75em auto .5em;
    text-align: center;
    background-color: #02111B;
    color: #6BF178;
    width: 75%;
    padding: .5em;
    border: .25em double #6bf178;
    line-height: 1.2em;
}

.modal-window-content {
    color: #02111B;
    background-color: #6bf178;
}

.modal-close {
    margin: auto;
    z-index: 999999;
    margin-right: 1vh;
    color: #02111B;
    background-color: #F50000;
    border: outset .15em #6BF178;
    font-weight: 700
}

.tab {
    background-color: rebeccapurple;
    color: #6bf178;
    font-family: 'Print Char';
    border-bottom: none;
    border-color: #02111B;
    padding: 0.5em;
}

.tab-selected {
    background-color: #02111B;
    color: #6bf178;
    border: solid 0.1em #6bf178;
    padding: 0.5em;
    font-family: 'Print Char';
}

.tab-container {
    border: solid .15em #02111B;
    padding: .5em;
    background-color: #6BF178;
    box-shadow: .25em .25em #02111B;
    color: #6BF178;
}

/* Alerts */
.dash-alert {
    border: dashed .2em;
    text-align: center;
    padding: .5em;
    background-color: #6BF178;
    color: #02111B;
}

select {
    background-color: #6BF178;
    color: rgba(2, 17, 27, .7);
    font-size: 1.2em;
    border: solid 0.1em #6BF178;
    width: 100%;
    text-align: center;
    padding: 0.25em;
    font-family: 'Print Char';
}

.modal-select {
    display: block;
    margin-bottom: .5em;
    background-color: #02111B;
    color: #6bf178;
    position: relative;
    border: .25em double;
    padding: .5em;
    font-size: 1em;
}

.scanning::before {
    content: " ";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    min-height: 100vh;
    bottom: 0;
    right: 0;
    background: linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.1) 50%), linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(0, 255, 0, 0.02), rgba(0, 0, 255, 0.06));
    z-index: 2;
    background-size: 100% 2px, 3px 100%;
    pointer-events: none;
}

@keyframes flicker {
    0% {
        opacity: 0.27861;
    }

    5% {
        opacity: 0.34769;
    }

    10% {
        opacity: 0.23604;
    }

    15% {
        opacity: 0.90626;
    }

    20% {
        opacity: 0.18128;
    }

    25% {
        opacity: 0.83891;
    }

    30% {
        opacity: 0.65583;
    }

    35% {
        opacity: 0.67807;
    }

    40% {
        opacity: 0.26559;
    }

    45% {
        opacity: 0.84693;
    }

    50% {
        opacity: 0.96019;
    }

    55% {
        opacity: 0.08594;
    }

    60% {
        opacity: 0.20313;
    }

    65% {
        opacity: 0.71988;
    }

    70% {
        opacity: 0.53455;
    }

    75% {
        opacity: 0.37288;
    }

    80% {
        opacity: 0.71428;
    }

    85% {
        opacity: 0.70419;
    }

    90% {
        opacity: 0.7003;
    }

    95% {
        opacity: 0.36108;
    }

    100% {
        opacity: 0.24387;
    }
}

.scanning::after {
    content: " ";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(18, 16, 16, 0.1);
    opacity: 0;
    z-index: 2;
    min-height: 100vh;
    pointer-events: none;
    animation: flicker 0.2s infinite;
}`, "",{"version":3,"sources":["webpack://./src/assets/custom.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mFAAwE;AAC5E;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAyB;IACzB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;;CAEC;;AAED;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;AACA;;AAEA;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yDAAwC;IACxC,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;;CAEC;AACD;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;;CAEC;;AAED;IACI,QAAQ;IACR,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,4BAA4B;IAC5B,kCAAkC;IAClC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,aAAa;IACb,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,+BAA+B;IAC/B,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,2BAA2B;IAC3B,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,SAAS;IACT,QAAQ;IACR,yKAAyK;IACzK,UAAU;IACV,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,iCAAiC;IACjC,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;AACpC","sourcesContent":[".text-load-in {\n    text-align: left;\n    margin-top: .5em;\n    margin-bottom: .5em;\n    white-space: nowrap;\n    overflow: hidden;\n    font-size: .8em;\n}\n\n.text-status-complete {\n    color: #6BF178;\n}\n\n@font-face {\n    font-family: 'Print Char';\n    src: local('PrintChar'), url(./fonts/PrintChar21.ttf) format('truetype');\n}\n\n.printchar {\n    font-family: 'Print Char';\n}\n\n.button-startup {\n    color: #6BF178;\n    background-color: #02111B;\n    font-family: 'Print Char';\n    padding: 0.5em;\n    border: outset thick #6BF178;\n    outline: solid .1em #02111B;\n    margin: .5em;\n}\n\n.button {\n    color: #6BF178;\n    background-color: #02111B;\n    font-family: 'Print Char';\n    padding: 0.5em;\n    border: outset medium #6BF178;\n    outline: solid .1em #02111B;\n}\n\n.button-inverted {\n    color: #02111B;\n    background-color: #6BF178;\n    border: outset medium #6BF178;\n    font-family: 'Print Char';\n    padding: .5em;\n    outline: solid .1em #02111B;\n}\n\n/*\nStartup\n*/\n\n.gs-top {\n    white-space: pre;\n    margin: auto;\n    text-align: center;\n}\n.gs-top-mobile {\n    white-space: pre;\n    margin: auto;\n    text-align: center;\n    font-size: .5em;\n}\n\n.gs-mobile-screen {\n    padding: .5em;\n}\n\n.gs-info-desktop {\n    min-height: 50vh;\n    margin: 2em;\n    font-size: 1.1em;\n}\n\n.gs-info-mobile {\n    font-size: 1.1em;\n}\n\n.gs-screen-right {\n    display: grid;\n    font-size: 1.25em;\n}\n\n.gs-info-title {\n    background-color: #6bf178;\n    color: #02111B;\n    padding: .5em;\n}\n\n.gs-info-command {\n    display: flex;\n    font-family: 'Print Char';\n}\n\n.gs-info-command-user {\n    color: red;\n}\n\n.gs-info-command-namespace {\n    color: cyan;\n}\n\n.gs-info-command-prompt {\n    white-space: nowrap;\n    overflow: hidden;\n    text-align: left;\n}\n\n.gs-info-content {\n    padding: .5em;\n}\n.gs-info-user {\n\n}\n\n.gs-image-container {\n    border: solid .1em;\n    margin: .5em;\n    background-image: url(\"./images/so.png\");\n    background-position: center;\n    background-size: cover;\n}\n\n/*\nShortcuts\n*/\n.shortcut-name {\n    background-color: #6BF178;\n    color: #02111B;\n    padding: 0.25em;\n    align-items: center;\n    display: grid;\n    text-align: center;\n}\n\n/*\nModal Options\n*/\n\n.modal-window-defaults {\n    top: 30%;\n    max-width: 100%;\n    position: relative;\n    color: #6BF178;\n    z-index: 99;\n    left: 1em;\n    position: absolute;\n    padding: 0;\n    border: .25em double #6BF178;\n    background-color: rgba(2,17,27,.7);\n    font-family: 'Print Char';\n    font-size: 1.1em;\n}\n\n.title-bar {\n    display: flex;\n    background-color: #02111B;\n    color: #6BF178;\n    border-bottom: solid .1em #6bf178;\n}\n\n.title-tray {\n    max-width: 100%;\n    display: flex;\n}\n\n.modal-title {\n    width: 100%;\n    margin: auto;\n    padding: .75em;\n}\n\n.modal-window-background {\n    margin: .1em;\n    display: grid;\n    padding: .5em;\n    background-color: rebeccapurple;\n}\n\n.modal-window-container {\n    margin: .25em;\n    border: .25em double;\n    padding: .5em;\n    background-color: #02111B;\n}\n\n.modal-window-heading {\n    margin: -1.75em auto .5em;\n    text-align: center;\n    background-color: #02111B;\n    color: #6BF178;\n    width: 75%;\n    padding: .5em;\n    border: .25em double #6bf178;\n    line-height: 1.2em;\n}\n\n.modal-window-content {\n    color: #02111B;\n    background-color: #6bf178;\n}\n\n.modal-close {\n    margin: auto;\n    z-index: 999999;\n    margin-right: 1vh;\n    color: #02111B;\n    background-color: #F50000;\n    border: outset .15em #6BF178;\n    font-weight: 700\n}\n\n.tab {\n    background-color: rebeccapurple;\n    color: #6bf178;\n    font-family: 'Print Char';\n    border-bottom: none;\n    border-color: #02111B;\n    padding: 0.5em;\n}\n\n.tab-selected {\n    background-color: #02111B;\n    color: #6bf178;\n    border: solid 0.1em #6bf178;\n    padding: 0.5em;\n    font-family: 'Print Char';\n}\n\n.tab-container {\n    border: solid .15em #02111B;\n    padding: .5em;\n    background-color: #6BF178;\n    box-shadow: .25em .25em #02111B;\n    color: #6BF178;\n}\n\n/* Alerts */\n.dash-alert {\n    border: dashed .2em;\n    text-align: center;\n    padding: .5em;\n    background-color: #6BF178;\n    color: #02111B;\n}\n\nselect {\n    background-color: #6BF178;\n    color: rgba(2, 17, 27, .7);\n    font-size: 1.2em;\n    border: solid 0.1em #6BF178;\n    width: 100%;\n    text-align: center;\n    padding: 0.25em;\n    font-family: 'Print Char';\n}\n\n.modal-select {\n    display: block;\n    margin-bottom: .5em;\n    background-color: #02111B;\n    color: #6bf178;\n    position: relative;\n    border: .25em double;\n    padding: .5em;\n    font-size: 1em;\n}\n\n.scanning::before {\n    content: \" \";\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    min-height: 100vh;\n    bottom: 0;\n    right: 0;\n    background: linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.1) 50%), linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(0, 255, 0, 0.02), rgba(0, 0, 255, 0.06));\n    z-index: 2;\n    background-size: 100% 2px, 3px 100%;\n    pointer-events: none;\n}\n\n@keyframes flicker {\n    0% {\n        opacity: 0.27861;\n    }\n\n    5% {\n        opacity: 0.34769;\n    }\n\n    10% {\n        opacity: 0.23604;\n    }\n\n    15% {\n        opacity: 0.90626;\n    }\n\n    20% {\n        opacity: 0.18128;\n    }\n\n    25% {\n        opacity: 0.83891;\n    }\n\n    30% {\n        opacity: 0.65583;\n    }\n\n    35% {\n        opacity: 0.67807;\n    }\n\n    40% {\n        opacity: 0.26559;\n    }\n\n    45% {\n        opacity: 0.84693;\n    }\n\n    50% {\n        opacity: 0.96019;\n    }\n\n    55% {\n        opacity: 0.08594;\n    }\n\n    60% {\n        opacity: 0.20313;\n    }\n\n    65% {\n        opacity: 0.71988;\n    }\n\n    70% {\n        opacity: 0.53455;\n    }\n\n    75% {\n        opacity: 0.37288;\n    }\n\n    80% {\n        opacity: 0.71428;\n    }\n\n    85% {\n        opacity: 0.70419;\n    }\n\n    90% {\n        opacity: 0.7003;\n    }\n\n    95% {\n        opacity: 0.36108;\n    }\n\n    100% {\n        opacity: 0.24387;\n    }\n}\n\n.scanning::after {\n    content: \" \";\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(18, 16, 16, 0.1);\n    opacity: 0;\n    z-index: 2;\n    min-height: 100vh;\n    pointer-events: none;\n    animation: flicker 0.2s infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
